import { render, staticRenderFns } from "./ListTaskAttachments.vue?vue&type=template&id=c2a3e17c&"
import script from "./ListTaskAttachments.vue?vue&type=script&lang=ts&"
export * from "./ListTaskAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports